import React from 'react'
import './about.scss'
import {
   FaEnvelope,
   FaPhoneAlt,
   FaGithub,
   FaBitbucket,
   FaInstagram,
} from 'react-icons/fa'

function About() {
   const info = [
      {
         icon: <FaEnvelope className="icon" />,
         value: 'mymbugua@gmail.com',
      },
      {
         icon: <FaPhoneAlt className="icon" />,
         value: '+254 716 390 878',
      },
      {
         icon: <FaGithub className="icon" />,
         value: 'https://github.com/newtfrank',
      },
      {
         icon: <FaBitbucket className="icon" />,
         value: 'https://bitbucket.org/newtou',
      },
      {
         icon: <FaInstagram className="icon" />,
         value: '@_la_photon',
      },
   ]

   const activities = [
      'Fullstack development',
      'Solving problems',
      'Creating products',
      'Website Design',
   ]

   const hobbies = ['Photography', 'Drawing', 'Anime', 'Manga']
   return (
      <div className="about">
         <div className="about__wrapper">
            <div className="about__wrapper--profile">
               <h3 className="about__wrapper--profile-title">About</h3>

               <h5>What i do</h5>
               <ul>
                  {activities.map((activity, index) => (
                     <li key={index}>{activity}</li>
                  ))}
               </ul>
               <br />
               <h5>Hobbies</h5>
               <ul>
                  {hobbies.map((hobby, index) => (
                     <li key={index}>{hobby}</li>
                  ))}
               </ul>
               <div className="about__wrapper--profile-img">
                  <img src="/images/newton.jpeg" alt="profile" />
               </div>
            </div>
            <div className="about__wrapper--content">
               <h2>About Me</h2>
               <div className="about__wrapper--content-info">
                  {info.map((item, index) => (
                     <div key={index} className="infoitem">
                        <span>{item.icon}</span>
                        <p>{item.value}</p>
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </div>
   )
}

export default About
